import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
  USER_WALLET,
} from "./types";
import AuthService from "../../services/auth.service";

export const login = (username, password) => (dispatch) => {
  return AuthService.login(username, password).then(
    (data) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data },
      });

      return Promise.resolve();
    },
    (error) => {
      loginErr(error, dispatch);
    }
  );
};

function loginErr(error, dispatch) {
  const message =
    (error.response && error.response.data && error.response.data.errors) ||
    error.message ||
    error.toString();

  dispatch({
    type: LOGIN_FAIL,
  });

  dispatch({
    type: SET_MESSAGE,
    payload: message,
  });
}

export const loginStrava = (user) => (dispatch) => {
  dispatch({
    type: LOGIN_SUCCESS,
    payload: { user: user },
  });

  return Promise.resolve();
};

export const logout = () => (dispatch) => {
  AuthService.logout();
  dispatch({
    type: LOGOUT,
  });
};

export const setUserWallet = (user) => (dispatch) => {
  dispatch({
    type: USER_WALLET,
    payload: { user },
  });
  return Promise.resolve();
};

export const setAuthenticateUser = (data) => (dispatch) => {
  console.log("setAuthenticateUser: ", data);
  dispatch({
    type: LOGIN_SUCCESS,
    payload: { user: data },
  });
  return Promise.resolve();
};
